import React from "react";
import PostData from "../../../packs_helper/scripts/PostData";
import CsGo from "../../../assets_v3/images/cs-go";
import PanelSkinBox from "./PanelSkinBox";
import PopUp from "../../Common/PopUp";
import Paginate from "../../Common/Paginate";
import PanelSkinMiniBox from "./PanelSkinMiniBox";
// import ImagePath from "../../../packs_helper/scripts/ImagePath";

const images = {
	20336: '/assets/user-panel/cs-go.svg',
	21209: '/assets/user-panel/dota-2.svg',
	21224: '/assets/user-panel/rust.svg'
};

class SellNow extends React.Component {
	constructor(props) {
		super(props);

		const { selected_game } = Object.fromEntries(
			new URL(window.location.href).searchParams
		);
		this.selectedGame = parseInt(selected_game);

		this.state = {
			selectedGame: null,
			categories: [],
			skin_games: [],
			tradeUrl: '',
			page: 1,
			total_page: 1,
			skins: [],
			selectedOriginalSkins: [],
			floatLoading: true,
			selectedSkins: [],
			selectedSkinsCount: 0,
			agreementChecked: false,
			sendDisabled: false,
			tradeSecurityMessage: false,
			wait_message: "",
		};

		this.ChangeGame = this.ChangeGame.bind(this);
		this.UpdateTradeUrl = this.UpdateTradeUrl.bind(this);
		this.GetInventory = this.GetInventory.bind(this);
		this.DelInventory = this.DelInventory.bind(this);
		this.GetGames = this.GetGames.bind(this);
		this.SelectionChange = this.SelectionChange.bind(this);
		this.SelectedSkinsHandler = this.SelectedSkinsHandler.bind(this);
		this.SendSelectedSkins = this.SendSelectedSkins.bind(this);
	}

	componentDidMount() {
		this.GetGames();
	}

	GetGames() {
		PostData("/ilan-oyunlari", {
			type: "skins",
		}).then((response) => {
			const {
				categories,
				rate,
				suggestedPriceRate,
				maximumPriceRate,
				confirmed_store_rate,
			} = response;
			
			const categoryItems = categories.map((category) => ({
				...category,
				image_url: images[category.id]
			}));

			if(!this.selectedGame || categoryItems.findIndex(categoryItem => categoryItem.id === this.selectedGame) === -1){
				this.selectedGame = categoryItems[0].id
			}

			this.setState({
				...response,
				categories: categoryItems,
				selectedGame: this.selectedGame,
			}, () => {
				this.selectedGame = null
			});
		});
	}

	ChangeGame(selectedGame) {
		this.setState({ selectedGame });
	}

	UpdateTradeUrl(e) {
		const tradeUrl = e.currentTarget.value;
		this.setState({ tradeUrl });
	}

	CheckInventory(page) {
		const checkInventory = (requested_page) => {
			const app_id = this.state.skin_games.find(
				(skin_game) => skin_game.cat_id == this.state.selectedGame
			).app_id;
			PostData("/envanteri-getir/" + app_id, { cs_go_sell_us: true, trade_url: this.state.tradeUrl, page: requested_page })
				.then((response) => {
					if (!response.wait) {
						clearInterval(this.inventoryInterval);
						this.setState({
							skins: Object.values(response.result),
							sendDisabled: false,
							floatLoading: false,
							total_page: response.total_pages || 1,
						});
					}
				})
				.catch(() => {
					clearInterval(this.inventoryInterval);
					ShowPopup({ message: "Envanterinizde uygun skin bulunamadı2!", title: "Hata" });
					this.setState({ sendDisabled: false, floatLoading: false });
				});
		};

		if (this.inventoryInterval) {
			clearInterval(this.inventoryInterval);
		}
		this.inventoryInterval = setInterval(() => checkInventory(page), 3000);
		checkInventory(page);
	}

	DelInventory() {
		this.setState({ sendDisabled: true, floatLoading: true, page: 1 });
		const app_id = this.state.skin_games.find(
			(skin_game) => skin_game.cat_id == this.state.selectedGame
		).app_id;
		PostData("/envanteri-yeniden-cek/" + app_id, { trade_url: this.state.tradeUrl, page: 1 })
			.then((response) => {
				this.GetInventory(1)
				this.setState({
					wait_message: "Bilgileriniz Steam'den yeniden getiriliyor."
				})
			})
			.catch((err) => { 
				console.error(err);
				ShowPopup({ message: "Envanter yenilenirken bir hata oluştu!", title: "Hata" });
				this.setState({ sendDisabled: false, floatLoading: false });
			});
	}

	GetInventory(page = 1) {
		this.setState({ sendDisabled: true, floatLoading: true, page: page });
		const app_id = this.state.skin_games.find(
			(skin_game) => skin_game.cat_id == this.state.selectedGame
		).app_id;
		PostData("/envanteri-getir/" + app_id, { cs_go_sell_us: true, trade_url: this.state.tradeUrl, page: page })
			.then((response) => {
				if (response.wait) {
					this.CheckInventory(page);
					this.setState({
						wait_message: "İlanlarınızın asset ve float bilgileri güncelleniyor, lütfen bekleyin...",
					});
				} else {
					if (response.result && Array.isArray(response.result)) {
						this.setState({
							sendDisabled: false,
							floatLoading: false,
							total_page: response.total_pages || 1,
							skins: response.result,
						});
					} else {
						this.setState({
							sendDisabled: false,
							floatLoading: false,
							total_page: response.total_pages || 1,
							skins: [],
						});
					}
				}
			})
			.catch((err) => { this.setState({sendDisabled: false}); });
	}

	SendSelectedSkins() {
		this.setState({ sendDisabled: true });
		const formData = new FormData();

		if (!this.state.agreementChecked) {
			ShowPopup({ message: "Lütfen sözleşmeyi onaylayınız!", title: "Hata" });
			this.setState({ sendDisabled: false });
			return false;
		}

		formData.append("product[category_id]", this.state.selectedGame);
		formData.append("active", true);
		formData.append("product[cs_go_sell_us]", true);

		const selectedSkins = this.state.selectedSkins;
		if (selectedSkins.length === 0) {
			ShowPopup({ message: "Hiç seçim yapmadınız!", title: "Hata" });
			this.setState({ sendDisabled: false });
			return false;
		}

		this.state.selectedSkins.forEach((selectedSkin) => {
			formData.append(`skins[${selectedSkin.assetid}][quantity]`, selectedSkin.quantity);
			formData.append(`skins[${selectedSkin.assetid}][price]`, selectedSkin.cost);
			formData.append(`skins[${selectedSkin.assetid}][description]`, selectedSkin.description);
		});

		PostData("/item-ilani-ver", formData).then((response) => {
			if (response.state) {
				this.props.ChangeRoute("/satislarim");
			}
      else{
  			this.setState({ sendDisabled: false });
      }
		});
	}

	SelectedSkinsHandler(status, skinData) {
		// PanelSkinMiniBox'dan gelen skin
		if (this.state.selectedOriginalSkins.some(skin => skin.assetid === skinData.assetid)) {
			this.setState((prevState) => ({
				selectedOriginalSkins: prevState.selectedOriginalSkins.filter(skin => skin.assetid !== skinData.assetid)
			}));
			this.SelectionChange(false, { assetid: skinData.assetid });
		} else {
			this.setState((prevState) => ({
				selectedOriginalSkins: [...prevState.selectedOriginalSkins, skinData]
			}));
		}
	} 

	SelectionChange(status, itemObj) {
		// PanelSkinBox'dan gelen itemObj
		/*
			assetid: props.assetid,
			quantity: 1,
			description: "",
			cost: +suggestedPrice,
		*/
		const selectedSkins = this.state.selectedSkins;

		const index = selectedSkins.findIndex((selectedSkin) => selectedSkin.assetid === itemObj.assetid);

		if (index > -1) {
			if (status) {
				selectedSkins[index].quantity = itemObj.quantity;
				selectedSkins[index].description = itemObj.description;
				selectedSkins[index].cost = itemObj.cost;
				this.setState({ selectedSkins, selectedSkinsCount: selectedSkins.length });
			} else {
				selectedSkins.splice(index, 1);
				this.setState({ selectedSkins, selectedSkinsCount: selectedSkins.length });
			}
		} else {
			selectedSkins.push(itemObj);
			this.setState({ selectedSkins, selectedSkinsCount: selectedSkins.length });
		}
	}

	render() {
		return (
			<React.Fragment>
				<div className="skin-query-grid">
					<SelectForSkin
						options={this.state.categories}
						onChange={this.ChangeGame}
						selected={this.state.selectedGame}
					/>

					<div className="skin-query-grid-form">
						<label htmlFor="query-form">TRADE URL:</label>
						<input
							id="query-form"
							type="text"
							value={this.state.tradeUrl}
							onChange={this.UpdateTradeUrl}
							placeholder="Trade URL'nizi buraya yapıştırın"
						/>
						<button className="btn btn-blue" disabled={this.state.sendDisabled} onClick={() => {
							this.setState({ skins: [], selectedSkins: [], selectedOriginalSkins: [], selectedSkinsCount: 0, wait_message: "", page: 1, total_page: 1 });
							this.GetInventory(1);
						}}>
							Envanteri Getir
						</button>
						{this.state.skins.length > 0 && (
							<button className="btn btn-red" 
								title="Envanteri Steamden Yeniden Çek"
								disabled={this.state.sendDisabled} onClick={() => {
								this.setState({ skins: [], selectedSkins: [], selectedOriginalSkins: [], selectedSkinsCount: 0, wait_message: "", page: 1, total_page: 1 });
								this.DelInventory();
							}}>
								<svg className="icon">
									<use xlinkHref="#gs-icon-user-panel-reload"></use> 
								</svg> Yeniden Çek
							</button>
						)}
						<a href="https://steamcommunity.com/id/example/tradeoffers/privacy#trade_offer_access_url" target="_blank" className="btn btn-orange">
							<svg className="icon">
								<use xlinkHref="#gs-icon-user-panel-steam"></use>
							</svg>
						</a>
					</div>
				</div>

					<React.Fragment>
						{this.state.skins.length > 0 && 
							<div className="pagination-buttons">
								<Paginate
									onChange={(page) => {
										this.setState({ page, sendDisabled: true });
										this.GetInventory(page);
									}}
									total_count={this.state.total_page * 16}
									current_page={this.state.page}
									per_page={16}
								/>
							</div>
						}
						{this.state.sendDisabled ? (
							<div className={'skin-query-grid-loading'}>
								<img 
									src={require("../../../assets_v3/images/loading-animation.svg")} 
									alt="loading" 
									width={96}
									height={96}
								/>
								<div>Envanter Yükleniyor...</div>
								<div>{this.state.wait_message}</div>
							</div>
						): (
							<div className="skin-result-grid">
								{this.state.skins.map((skin) => {
									return (
										<PanelSkinMiniBox
											key={skin.market_name + skin.keys[0]}
											SelectedSkinsHandler={this.SelectedSkinsHandler}
											skin={skin}
											active={this.state.selectedOriginalSkins.some((s) => s.assetid === skin.assetid)}
										/>
									)})}
							</div>
						)}
						{this.state.skins.length > 0 && 
							<div className="pagination-buttons">
								<Paginate
									onChange={(page) => {
										this.setState({ page, sendDisabled: true });
										this.GetInventory(page);
									}}
									total_count={this.state.total_page * 16}
									current_page={this.state.page}
									per_page={16}
								/>
							</div>
						}
						<hr />
						<div className="skin-result-grid">
							{this.state.selectedOriginalSkins.map((skin) => (
								<PanelSkinBox
									key={skin.market_name + skin.keys[0]}
									suggestedPriceRate={this.state.suggestedPriceRate}
									maximumPriceRate={this.state.maximumPriceRate}
									rate={this.state.rate}
									steamRate={this.state.steamRate}
									SelectionChange={this.SelectionChange}
									SelectedSkinsHandler={this.SelectedSkinsHandler}
									{...skin}
									sellNow={true}
								/>
							))}
						</div>

						{this.state.skins.length !== 0 && (
							<div className="skin-result-footer">
								<div className="checkbox">
									<input
										type="checkbox"
										name="sale_agreement"
										id="sale_agreement"
										onChange={(e) =>
											this.setState({ agreementChecked: e.currentTarget.checked })
										}
									/>
									<label htmlFor="sale_agreement">
										<div>
											<a href="/kullanici-sozlesmesi#oyuncu-pazari" target="_blank">
												Oyuncu Pazarı Sözleşmesi
											</a>{" "}
											ve şartlarını okudum kabul ediyorum.
										</div>
									</label>
								</div>

								<div className="skin-result-footer-info">
									{this.state.selectedSkinsCount} Adet Eklendi
								</div>

								<button
									className="btn btn-blue"
									onClick={() => { this.setState({ popup: "trade_security_message" }) }}
									disabled={
										this.state.sendDisabled ||
										this.state.selectedSkins.length === 0
									}
								>
									TEKLİF AL
								</button>
							</div>
					 )}

						{this.state.popup === "trade_security_message" && (
							<PopUp
								title="Önemli Bilgilendirme"
								Hide={() => this.setState({ popup: null })}
								className="settings-popup"
							>
								<div>Size verilen teklifi kabul ederseniz, takas sonrası bakiyeniz 8 gün sonra hesabınıza eklenecektir.</div>
								<br />
								<div>Bu uygulama <a href="https://help.steampowered.com/tr/faqs/view/365F-4BEE-2AE2-7BDD" target="_blank"><u><b>Steam'in Trade Protection</b></u></a> güncellemesi nedeniyle yapılmaktadır.</div>
								<hr />
								<div style={{display: 'flex', gap: '10px'}}>
									<button className="btn btn-red" style={{width: '100%'}} onClick={() => {
										this.setState({ popup: null });
									}}>Vazgeç</button>
									<button className="btn btn-jungle" style={{width: '100%'}} onClick={() => {
										this.SendSelectedSkins(); this.setState({ popup: null });
									}}>
									Teklif Al
									</button>
								</div>
							</PopUp>
						)}
					</React.Fragment>
			</React.Fragment>
		);
	}
}

class SelectForSkin extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: null,
			isOpen: false,
		};

		this.ToggleSelect = this.ToggleSelect.bind(this);
		this.SetSelected = this.SetSelected.bind(this);
		this.RemoveSelected = this.RemoveSelected.bind(this);
	}

	// componentDidMount() {
	// 	if(this.props.selected){
	// 		this.setState({
	// 			selected: this.props.selected
	// 		})
	// 	}
	// }

	ToggleSelect() {
		this.setState((prevState) => ({
			isOpen: !prevState.isOpen,
		}));
	}

	SetSelected(e) {
		const selectedOption = e.currentTarget;
		this.props.onChange(selectedOption.value);
		this.setState({
			selected: selectedOption.value,
			isOpen: false,
		});
	}

	RemoveSelected() {
		this.setState({
			selected: null,
			isOpen: false,
		});
	}

	render() {
		const selectedItem = this.props.options.find(
			(option) => option.id == this.props.selected
		);
		return (
			<div className={"select" + (this.state.isOpen ? " open" : "")}>
				{selectedItem && (
					<label onClick={this.ToggleSelect}>
						<svg className="icon">
							<use xlinkHref="#gs-icon-user-panel-caret-down"></use>
						</svg>
						<img src={selectedItem.image_url || CsGo} alt={selectedItem.name} width={96} height={48} />
					</label>
				)}
				<div className="options">
					{/*					<button type="button" onClick={this.RemoveSelected}><img src={CsGo} /></button>
					 */}{" "}
					{this.props.options.map((option) => (
						<button
							type="button"
							onClick={this.SetSelected}
							value={option.id}
							key={option.id + option.name}
						>
							<svg className="icon">
							</svg>
							<img src={option.image_url || CsGo} alt={option.name} width={96} height={48} />
						</button>
					))}
				</div>
			</div>
		);
	}
}

export default SellNow;
